import { defineNuxtPlugin } from 'nuxt/app';
import { apiEventInit } from '../api/events';

// 应用初始化行为，通过hook监听，在app初始化时执行
export default defineNuxtPlugin(nuxtApp => {
  apiEventInit();
});
